import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { ChatService } from "../services/chat.service";
import { FaqService } from "../services/faq.service";
import { SelectTourDialogComponent } from "../tour/select-tour-dialog/select-tour-dialog.component";
import { helpFabAnimations } from "./help-fab.animations";
import { PerfilService } from "../services/ajs-perfil.service";
import { ClienteResource } from "../services/ajs-cliente-resource.service";
import { TutorialApiService } from "../services/api/tutorial-api.service";
import { tap, startWith, switchMap, catchError } from "rxjs/operators";
import { of } from "rxjs";
import { emRetornoDeLogin } from "../../angularjs-app/services/auth/keycloak/keycloak.util";
import { temChat } from "../categoria-cliente";

interface FabMenuItem {
  icon: string;
  title: string;
  click?: () => void;
}

@Component({
  selector: "mandae-help-fab",
  templateUrl: "./help-fab.component.html",
  styleUrls: ["./help-fab.component.scss"],
  animations: helpFabAnimations,
})
export class HelpFabComponent implements OnInit {
  fabButtons: FabMenuItem[] = [
    {
      icon: "book",
      title: "FAQ",
      click: () => this.faqService.showFaqWindow(),
    },
    {
      icon: "gps_fixed",
      title: "Iniciar tour virtual",
      click: () => this.dialog.open(SelectTourDialogComponent),
    },
  ];
  buttons = [];
  fabTogglerState = "inactive";
  firstStepsFinished: Boolean = false;

  constructor(
    private perfilService: PerfilService,
    private clienteResource: ClienteResource,
    private tutorialApiService: TutorialApiService,
    private chatService: ChatService,
    private faqService: FaqService,
    private dialog: MatDialog
  ) {}

  showItems() {
    this.fabTogglerState = "active";
    this.buttons = this.fabButtons;
    // Minimiza o chat ao abrir o menu para que ele não fique sobreposto aos botões.
    this.chatService.minimizeChatWindow();
  }

  hideItems() {
    this.fabTogglerState = "inactive";
    this.buttons = [];
  }

  onToggleFab() {
    this.buttons.length ? this.hideItems() : this.showItems();
  }

  /** Mensagens não lidas do chat, para exibir o badge na bolinha. */
  get unreadMessages$() {
    return this.chatService.unreadMessages$;
  }

  async ngOnInit() {
    // On the Keycloak return page the sign-in is still being completed: any token in the storage is the
    // previous session's, and the call would only come back 401.
    if (localStorage.getItem("ls.token") && !emRetornoDeLogin()) {
      this.tutorialApiService.shouldUpdate
        .pipe(
          startWith({}),
          switchMap(() =>
            this.tutorialApiService
              .getTutorialCompletion()
              .pipe(catchError(() => of({ finalizado: false })))
          ),
          tap((completionStatus) => {
            this.firstStepsFinished = completionStatus.finalizado;
            this.updateChatButton();
          })
        )
        .subscribe();
    }
  }

  public handleClick(item: FabMenuItem) {
    if (!item || !item.click) {
      return;
    }

    this.hideItems();
    item.click();
  }

  private updateChatButton() {
    if (this.fabButtons.some((fb) => fb.icon === "chat")) {
      return;
    }

    const user = this.perfilService.getCacheUserData();

    if (user) {
      if (temChat(user)) {
        this.fabButtons.unshift({
          icon: "chat",
          title: "Chat",
          click: () => this.chatService.showChatWindow(),
        });
        // Passa a ouvir mensagens não lidas para exibir o badge na bolinha.
        this.chatService.listenUnreadMessages();
      }
    }
  }
}
